import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useWebGalleryStore } from "../../hooks";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";
import { Button } from "../../lib/Button";
interface IViewPortToggleParamTypes {
  galleryId: string;
  assetId: string;
}

export const ViewPortToggle: React.FunctionComponent = () => {
  const store = useWebGalleryStore();
  let { t } = useCustomTranslation("Header");
  const { galleryId, assetId } = useParams<IViewPortToggleParamTypes>();
  const defaultAssetId = store?.selectedAsset?.id || store?.assets[0]?.id;
  const [isDetailView, setIsDetailView] = useState(false);

  useEffect(() => {
    setIsDetailView(!!assetId);
  }, [assetId]);

  const activeToggleStyles = "viewport-toggle-button active";
  const inactiveToggleStyles = "viewport-toggle-button";

  return (
    <div className="viewport-toggle">
      <Link
        to={`/${galleryId}-ExternalUser`}
        className="viewport-toggle__link"
        aria-hidden
      >
        <Button
          className={(isDetailView ? inactiveToggleStyles : activeToggleStyles) + ' web-gallery-grid-view-pendo-tracking'}
          aria-label="Navigate to Gallery Grid View"
        >
          {t("Grid")}
        </Button>
      </Link>
      <Link
        to={`/${galleryId}-ExternalUser/${defaultAssetId}`}
        className="viewport-toggle__link"
        aria-hidden
      >
        <Button
          className={(isDetailView ? activeToggleStyles : inactiveToggleStyles) + ' web-gallery-details-view-pendo-tracking'}
          aria-label="Navigate to Gallery Detail View"
        >
          {t("Gallery")}
        </Button>
      </Link>
    </div>
  );
};
